import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatioLandscape = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.333 0C16.8057 0 17.9999 1.2535 18 2.7998V11.2002C17.9999 12.7465 16.8057 14 15.333 14H2.66699C1.1943 14 0.0001 12.7465 0 11.2002V2.7998C0.0001 1.2535 1.19429 0 2.66699 0H15.333ZM2.66699 7.7012C2.29886 7.7012 2.0001 8.0149 2 8.4014V11.2012C2 11.5878 2.2988 11.9014 2.66699 11.9014H6.66699C7.035 11.9012 7.333 11.5877 7.333 11.2012C7.3328 10.8149 7.0349 10.5021 6.66699 10.502H5.33301C4.22859 10.5018 3.33301 9.5611 3.33301 8.4014C3.33291 8.015 3.03497 7.7014 2.66699 7.7012ZM11 2.10156C10.6318 2.10156 10.333 2.41516 10.333 2.80176C10.3331 3.18827 10.6319 3.50195 11 3.50195H13C13.9205 3.50195 14.667 4.28545 14.667 5.252C14.6672 5.6383 14.9651 5.951 15.333 5.9512C15.7011 5.9512 15.9998 5.6384 16 5.252V2.80176C16 2.41516 15.7012 2.10156 15.333 2.10156H11Z",
		fill: "#545F7E"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatioLandscape);
export default ForwardRef;
